export const Roles = {
  admin: 'admin',
  superAdmin: 'super_admin',
};
